<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/bruno-giacosa')">Bruno Giacosa
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/cantina-roberto-voerzio')">Cantina Roberto
                        Voerzio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/conterno-fantino')">Conterno Fantino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/g-d-vajra')">G. D. Vajra
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/gaja')">Gaja
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giacomo-conterno')">Giacomo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio')">Giuseppe
                        Mascarello e Figlio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/massolino')">Massolino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/poderi-aldo-conterno')">Poderi Aldo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/roagna')">Roagna
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/tenuta-la-giustiniana')">Tenuta La
                        Giustiniana
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/vigne-marina-coppi')">Vigne Marina Coppi
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Giuseppe Mascarello e Figlio</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Il terzo produttore nella trinità dei colossi del Barolo (gli altri due sono Giacomo Contorno e
                        Bruno Giacosa), Giuseppe Mascarello ha ai suoi piedi il mondo del vino italiano. Con i piedi ben saldi
                        piantato nel passato ma con gli occhi rivolti all'orizzonte, si trova a cavallo tra il vecchio mondo e il nuovo
                        con brio ardente. Dedicato al lungo invecchiamento in vecchie botti (botti), secondo Antonio
                        Galloni, "Mascarello produce alcuni dei vini più avvincenti e tradizionali del Piemonte".
                    </div>

                    <div class="howto-title2">Il Manifesto di Mascarello</div>
                    <div class="howto-text">
                        L'azienda è oggi alla quarta generazione di Mascarello, e lo è dagli anni '60. Mauro
                        è il figlio nel nome, il figlio di Giuseppe (sebbene l'originale Giuseppe e figlio fossero suoi
                        bisnonno e nonno). Tuttavia, cosa c'è in un nome quando l'eredità e il savoir faire
                        risalgono alla metà del 1800 quando Giuseppe Mascarello si fece un nome gestendo la
                        vigneti di ricchi proprietari terrieri, e che alla fine si sono conclusi con l'acquisto del proprio
                        vigneti e cantine nel 1881 nel paese di Monforte d'Alba. Mauro possiede Monprivato nel suo
                        interezza, avendo acquistato tutti i pacchi che poteva dal suo mandato. Questa è un'ottima notizia per
                        Investitori di vini italiani come vini da singolo vigneto, in particolare quelli realizzati con un metodo tradizionale
                        avvicinarsi all'età in modo superbo. In poche parole, questo è un Barolo brillante come tutti gli altri produttori di Barolo
                        cercare ispirazione.
                    </div>

                    <div class="howto-title2">Il buono, il brutto e il cattivo?</div>
                    <div class="howto-text">
                        Tuttavia, è risaputo che non tutti i cambiamenti hanno avuto successo universale. Nonostante fermo
                        rifiuti di Elena Mascarello (nipote di Mauro), negli ultimi anni qualcosa è cambiato.
                        Se è innegabile che le annate dell'epoca di Mauro siano considerate tra i migliori vini d'Italia,
                        (1986, 1988, 1999, 2001, 2004, 2008), sperimentazione recente (o meno, a seconda di chi
                        credere) significa che le nuove annate finora non sono riuscite a raggiungere l'apice del passato
                        pubblicazione. Questo non vuol dire che non siano ottimi esempi non solo del Barolo ma di tutti
                        Vino italiano - semplicemente che quando l'asticella è stratosfericamente alta, forse può essere difficile
                        raggiungere con costanza. Ma dobbiamo ricordare che questi sono vini costruiti per l'invecchiamento. Per il vero Barolo
                        appassionati, il Monprivato è il modello di ciò che dovrebbe essere il Barolo, soprattutto il Barolo tradizionale.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Osservando la profondità della presenza, calcolando la gamma di annate/formati di bottiglia di
                                ogni vino presente nelle carte dei vini dei 150 migliori ristoranti del mondo, Giuseppe
                                Il Monprivato di Mascarello e Figlio si è piazzato al nono posto nella classifica “Top 20 gainers” di Wine Lister
                                in presenza nei migliori ristoranti del mondo” 2018 e nello stesso anno, considerato a
                                “Miglior vino italiano” secondo i punteggi della critica aggregati su wine-searcher.com.
                            </li>
                            <li>I Winesider Best Italian Wine Awards, più semplicemente indicati come TWS-BIWA, hanno contribuito a spingere Giuseppe Mascarello e Figlio alla fama mondiale quando hanno assegnato la sesta posizione al Monprivato Ca d'Morissio del 2004 (ottenuto da uve utilizzando la selezione clonale all'interno del Monprivato) tra i “50 Best Italian Wines” nel 2012.
                            </li>
                            <li>Nel 2014 la TWS-BIWA ha assegnato al 2009 'Santo Stefano di Perno' la decima posizione all'interno della “50
                                Migliori Vini Italiani”. Nonostante l'avvicinarsi alla maturità massima nel 2023, il prezzo medio per questo
                                la celebrata annata continua a salire (+15%) nell'ultimo anno da giugno
                                2018.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Giuseppe Mascarello e Figlio</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Der dritte Produzent in der Dreifaltigkeit der Barolo-Giganten (die anderen beiden sind Giacomo Contorno und
                        Bruno Giacosa) liegt Giuseppe Mascarello die italienische Weinwelt zu Füßen. Mit festen Füßen
                        In der Vergangenheit verankert, den Blick aber auf den Horizont gerichtet, bewegt er sich zwischen der alten und der neuen Welt
                        mit glühendem Elan. Laut Antonio ist er der langen Reifung in alten Botti (Fässern) gewidmet
                        Galloni: „Mascarello stellt einige der überzeugendsten, traditionellsten Weine im Piemont her.“
                    </div>

                    <div class="howto-title2">Das Mascarello-Manifest</div>
                    <div class="howto-text">
                        Das Anwesen besteht heute in der vierten Generation aus Mascarellos, und das bereits seit den 1960er Jahren. Mauro
                        ist das figlio im Namen, der Sohn von Giuseppe (obwohl der ursprüngliche Giuseppe und sein Sohn ihm gehörten).
                        Urgroßvater und Großvater). Doch was steckt in einem Namen, wenn es um Erbe und Savoir-faire geht?
                        stammen aus der Mitte des 19. Jahrhunderts, als Giuseppe Mascarello sich als Manager einen Namen machte
                        Weinberge wohlhabender Grundbesitzer, die schließlich zum Erwerb eigener Weinberge führten
                        Weinberge und Keller im Jahr 1881 im Dorf Monforte d’Alba. Mauro ist Eigentümer von Monprivato
                        vollständig, nachdem er seit seiner Amtszeit alle Parzellen gekauft hatte, die er konnte. Das sind großartige Neuigkeiten für
                        Italienische Weininvestoren bevorzugen Weine aus einzelnen Weinbergen, insbesondere solche, die auf traditionelle Weise hergestellt werden
                        kommen dem Alter hervorragend entgegen. Einfach ausgedrückt ist dies ein brillanter Barolo als alle anderen Barolo-Produzenten
                        Suchen Sie nach Inspiration.
                    </div>

                    <div class="howto-title2">Das Gute, das Schlechte und das?</div>
                    <div class="howto-text">
                        Es ist jedoch allgemein bekannt, dass nicht alle Veränderungen universellen Erfolg hatten. Trotz fest
                        Aufgrund der Weigerungen von Elena Mascarello (Mauros Enkelin) hat sich in den letzten Jahren etwas verändert.
                        Während es unbestreitbar ist, dass Jahrgänge aus Mauros Zeit zu den besten Weinen Italiens zählen,
                        (1986, 1988, 1999, 2001, 2004, 2008), aktuelle Experimente (oder nicht, je nachdem, wen Sie haben).
                        glauben) bedeutet, dass es neueren Jahrgängen bisher nicht gelungen ist, den Höhepunkt der Vergangenheit zu erreichen
                        freigeben. Das soll nicht heißen, dass sie nicht hervorragende Beispiele nicht nur für Barolo, sondern für alle sind
                        Italienischer Wein – einfach, wenn die Messlatte stratosphärisch hoch liegt, kann es vielleicht schwierig sein
                        konsequent erreichen. Aber wir müssen bedenken, dass es sich um Weine handelt, die zum Altern bestimmt sind. Für echten Barolo
                        Liebhabern ist der Monprivato das Vorbild dafür, was Barolo – insbesondere traditioneller Barolo – sein sollte.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Beobachtung der Tiefe der Präsenz, Berechnung der Bandbreite an Jahrgängen/Flaschenformaten von
                                Jeder Wein, der auf den Weinkarten der 150 besten Restaurants der Welt steht, Giuseppe
                                Der Monprivato von Mascarello e Figlio belegte den neunten Platz in der Liste der „Top 20 Gewinner“ des Winelisters
                                in Präsenz in den besten Restaurants der Welt“ 2018 und im selben Jahr als a
                                „Bester italienischer Wein“ gemäß den auf wine-searcher.com zusammengefassten Kritikerbewertungen.
                            </li>
                            <li>Die Winesider Best Italian Wine Awards, einfacher als TWS-BIWA bezeichnet, trugen dazu bei, Giuseppe Mascarello e Figlio zu weltweitem Ruhm zu verhelfen, als sie den 2004 Monprivato Ca d'Morissio (hergestellt aus Trauben mittels klonaler Selektion innerhalb der …) mit dem sechsten Platz vergaben (Weinberg Monprivato) zu den „50 besten italienischen Weinen“ im Jahr 2012.
                            </li>
                            <li>Im Jahr 2014 verlieh die TWS-BIWA dem „Santo Stefano di Perno“ 2009 den zehnten Platz in der Kategorie „50
                                Beste italienische Weine“. Trotz der Annäherung an die Höchstreife im Jahr 2023 liegt der Durchschnittspreis dafür
                                Der gefeierte Jahrgang steigt im letzten Jahreszeitraum ab Juni weiter an (+15 %).
                                2018.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Giuseppe Mascarello e Figlio</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Le troisième producteur de la trinité des mastodontes de Barolo (les deux autres étant Giacomo Contorno et
                        Bruno Giacosa), Giuseppe Mascarello a le monde du vin italien à ses pieds. Avec ses pieds fermement
                        planté dans le passé mais les yeux tournés vers l'horizon, il chevauche l'ancien monde et le nouveau
                        avec un panache ardent. Dédié au long vieillissement dans de vieux botti (fûts), selon Antonio
                        Galloni, "Mascarello fait certains des vins traditionnels les plus convaincants du Piémont."
                    </div>

                    <div class="howto-title2">Le manifeste de Mascarello</div>
                    <div class="howto-text">
                        Le domaine en est aujourd'hui à sa quatrième génération de Mascarello, et ce depuis les années 1960. Mauro
                        est le figlio dans le nom, le fils de Giuseppe (bien que l'original Giuseppe et son fils étaient ses
                        arrière-grand-père et grand-père). Pourtant, qu'y a-t-il dans un nom quand l'héritage et le savoir-faire
                        remontent au milieu des années 1800 lorsque Giuseppe Mascarello s'est fait un nom en gérant le
                        vignobles de riches propriétaires terriens, et qui a finalement abouti à l'achat de son propre
                        vignobles et caves en 1881 dans le village de Monforte d'Alba. Mauro possède Monprivato dans sa
                        l'intégralité, ayant acheté toutes les parcelles qu'il a pu depuis son mandat. C'est une excellente nouvelle pour
                        Les investisseurs viticoles italiens en tant que vins de vignoble unique, en particulier ceux élaborés avec un
                        approcher superbement l'âge. En termes simples, c'est un Barolo brillant que tous les autres producteurs de Barolo
                        chercher l'inspiration.
                    </div>

                    <div class="howto-title2">Le bon, le mauvais et le?</div>
                    <div class="howto-text">
                        Cependant, il est de notoriété publique que tous les changements n'ont pas rencontré un succès universel. Malgré ferme
                        refus d'Elena Mascarello (la petite-fille de Mauro), quelque chose a changé ces dernières années.
                        S'il est indéniable que les millésimes de l'époque de Mauro sont considérés parmi les meilleurs vins d'Italie,
                        (1986, 1988, 1999, 2001, 2004, 2008), expérimentation récente (ou non, selon qui vous
                        croire) signifie que les nouveaux millésimes n'ont pas réussi jusqu'à présent à atteindre le zénith du passé sur
                        libérer. Cela ne veut pas dire qu'ils ne sont pas d'excellents exemples non seulement de Barolo, mais de tous
                        Vin italien - simplement que lorsque la barre est stratosphérique, il peut être difficile de
                        atteindre systématiquement. Mais il ne faut pas oublier que ce sont des vins taillés pour la garde. Pour le vrai Barolo
                        amoureux, le Monprivato est le modèle de ce que devrait être le Barolo - en particulier le Barolo traditionnel.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>Observer la profondeur de présence, calculer la gamme de millésimes/formats de bouteilles de
                                chaque vin présent sur les cartes des 150 meilleurs restaurants du monde, Giuseppe
                                Le Monprivato de Mascarello e Figlio était en neuvième position sur le "Top 20 gagnants" de la liste des vins
                                en présence dans les meilleurs restaurants du monde » 2018 et la même année, considérée comme une
                                "Meilleur vin italien" selon les notes des critiques agrégées sur wine-searcher.com.
                            </li>
                            <li>Les Winesider Best Italian Wine Awards, plus simplement appelés TWS-BIWA, ont contribué à propulser Giuseppe Mascarello e Figlio vers une renommée mondiale en attribuant la sixième place au Monprivato Ca d'Morissio 2004 (issu de raisins utilisant une sélection clonale au sein de la vignoble de Monprivato) parmi leurs « 50 meilleurs vins italiens » en 2012.
                            </li>
                            <li>En 2014, le TWS-BIWA a décerné la dixième place 2009 à "Santo Stefano di Perno" au sein des "50
                                Meilleurs vins italiens ». Malgré l'approche de la maturité maximale en 2023, le prix moyen de ce
                                millésime célébré continue de grimper (+15%) sur la dernière période d'un an à partir de juin
                                2018.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Giuseppe Mascarello e Figlio</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        The third producer in the trinity of Barolo behemoths (the other two being Giacomo Contorno and
                        Bruno Giacosa), Giuseppe Mascarello has the Italian wine world at his feet. With his feet firmly
                        planted in the past but eyes set towards the horizon, he straddles the old world and the new
                        with ardent panache. Dedicated to long ageing in old botti (barrels), according to Antonio
                        Galloni, “Mascarello makes some of the most compelling, traditional wines in Piedmont.”
                    </div>

                    <div class="howto-title2">The Mascarello Manifesto</div>
                    <div class="howto-text">
                        The estate is today in its fourth generation of Mascarellos, and has been since the 1960s. Mauro
                        is the figlio in the name, the son of Giuseppe (although the original Giuseppe and son were his
                        great-grandfather and grandfather). Still, what’s in a name when the heritage and savoir faire
                        date back to the mid-1800s when Giuseppe Mascarello made a name for himself managing the
                        vineyards of wealthy landowners, and which eventually ended up in the purchase of his own
                        vineyards and cellars in 1881 in the village of Monforte d’Alba. Mauro owns Monprivato in its
                        entirety, having purchased all the parcels he could since his tenure. This is great news for
                        Italian wine investors as single vineyard wines, particularly those made with a traditional
                        approach age superbly. Simply put, this is a brilliant Barolo that all other Barolo producers
                        look to for inspiration.
                    </div>

                    <div class="howto-title2">The good, the bad and the?</div>
                    <div class="howto-text">
                        However, it is common knowledge that not all change has met with universal success. Despite firm
                        refusals from Elena Mascarello (Mauro’s grand-daughter), something has shifted in recent years.
                        While it is undeniable that vintages from Mauro’s time are considered among Italy's best wines,
                        (1986, 1988, 1999, 2001, 2004, 2008), recent experimentation (or not, depending on whom you
                        believe) means that newer vintages have so far not managed to reach the zenith of the past upon
                        release. That is not to say that they are not excellent examples of not just Barolo but all
                        Italian wine - simply that when the bar is stratospherically high, it can perhaps be hard to
                        reach consistently. But we must remember that these are wines built for ageing. For true Barolo
                        lovers, the Monprivato is the model for what Barolo - especially traditional Barolo - should be.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>Observing the depth of presence, calculating the range of vintages/bottle formats of
                                each wine found on the wine lists of the world’s top 150 restaurants, Giuseppe
                                Mascarello e Figlio’s Monprivato was in ninth position on wine-lister’s “Top 20 gainers
                                in presence in the world’s best restaurants” 2018 and in the same year, considered a
                                “Best Italian Wine” according to critic scores aggregated on wine-searcher.com.
                            </li>
                            <li>The Winesider Best Italian Wine Awards, more simply referred to as TWS-BIWA helped propel Giuseppe Mascarello e Figlio to worldwide fame when they awarded the number six position to 2004 Monprivato Ca d’Morissio (made from grapes using clonal selection within the Monprivato vineyard) among their “50 Best Italian Wines” in 2012.
                            </li>
                            <li>In 2014 the TWS-BIWA awarded 2009 'Santo Stefano di Perno’ tenth position within the “50
                                Best Italian Wines”. Despite nearing peak maturity in 2023, the average price for this
                                celebrated vintage continues to climb (+15%) over the last one year period from June
                                2018.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GiuseppeMascarelloFiglio",
    head: {
        title: 'Giuseppe Mascarello e Figlio | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the rich tradition and expert craftsmanship of Giuseppe Mascarello e Figlio, a renowned wine producer in the Piedmont region of Italy. Explore their extensive selection of premium wines, crafted using traditional methods and the finest local grapes. Experience the true essence of Piedmont\'s winemaking heritage with a bottle from Giuseppe Mascarello e Figlio.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {
                report: 'Giuseppe Mascarello e Figlio',
                src: '/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio'
            },
            items: [
                {report: 'Bruno Giacosa', src: '/wine-guide/italy/piedmont/bruno-giacosa'},
                {report: 'Cantina Roberto Voerzio', src: '/wine-guide/italy/piedmont/cantina-roberto-voerzio'},
                {report: 'Conterno Fantino', src: '/wine-guide/italy/piedmont/conterno-fantino'},
                {report: 'G. D. Vajra', src: '/wine-guide/italy/piedmont/g-d-vajra'},
                {report: 'Gaja', src: '/wine-guide/italy/piedmont/gaja'},
                {report: 'Giacomo Conterno', src: '/wine-guide/italy/piedmont/giacomo-conterno'},
                {
                    report: 'Giuseppe Mascarello e Figlio',
                    src: '/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio'
                },
                {report: 'Massolino', src: '/wine-guide/italy/piedmont/massolino'},
                {report: 'Poderi Aldo Conterno', src: '/wine-guide/italy/piedmont/poderi-aldo-conterno'},
                {report: 'Roagna', src: '/wine-guide/italy/piedmont/roagna'},
                {report: 'Tenuta La Giustiniana', src: '/wine-guide/italy/piedmont/tenuta-la-giustiniana'},
                {report: 'Vigne Marina Coppi', src: '/wine-guide/italy/piedmont/vigne-marina-coppi'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
